var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / World") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-World",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(3.000000, 3.000000)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7066667,0.0366666667 C17.3883333,3.31666667 20,7.75666667 20,12.6666667 C20,17.5216667 17.3166667,22.0283333 13.7066667,25.2966667",
    id: "49040b86-9a6f-4772-a826-475df6e0e20b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6266667,0.0366666667 C7.945,3.31666667 5.33333333,7.75666667 5.33333333,12.6666667 C5.33333333,17.5216667 8.01666667,22.0283333 11.6266667,25.2966667",
    id: "97fb4027-f08c-4df5-9a9d-c3a77dfa9935"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.05533376e-13,
    y1: 12.6666667,
    x2: 25.3333333,
    y2: 12.6666667,
    id: "eda3c070-4fea-47b2-bbe0-96a13a6d2db2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.6666667,
    y1: 25.3333333,
    x2: 12.6666667,
    y2: -3.55271368e-14,
    id: "510cb99e-b750-4354-a439-7da9584eadc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3783333,4.53166667 C19.5,6.60166667 16.3,8 12.6666667,8 C9.08,8 5.84666667,6.59333333 2.95666667,4.53166667",
    id: "e316a602-f12a-49ea-8044-7bc467d3c5bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.96,20.8016667 C5.83333333,18.7316667 9.03666667,17.3333333 12.6666667,17.3333333 C16.2533333,17.3333333 19.4866667,18.74 22.3766667,20.8016667",
    id: "27926529-0b25-49fe-9f99-3796074da005"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.6666667,
    cy: 12.6666667,
    r: 12.6666667
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.e8a085a1e02a4334643acf25e565d89e.svg";
export { ForwardRef as ReactComponent };